import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { CheckCircle, Warning, Spinner, ArrowRight } from "@phosphor-icons/react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("pending");

  useEffect(() => {
    if (!token) { setStatus("invalid"); return; }
    (async () => {
      try {
        await api.post(`/auth/verify-email?token=${encodeURIComponent(token)}`);
        await refresh();
        setStatus("ok");
      } catch {
        setStatus("invalid");
      }
    })();
  }, [token, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FFFFFF] p-6">
      <div className="card-flat p-10 max-w-md w-full text-center" data-testid="verify-email-card">
        {status === "pending" && (
          <>
            <Spinner size={44} className="text-[#7C8B6E] mx-auto animate-spin" />
            <h1 className="font-editorial text-3xl mt-6">Verifica in corso...</h1>
          </>
        )}
        {status === "ok" && (
          <>
            <CheckCircle size={56} weight="fill" className="text-[#7C8B6E] mx-auto" />
            <h1 className="font-editorial text-4xl mt-6">Email <span className="italic-accent text-[#7C8B6E]">verificata</span>.</h1>
            <p className="mt-4 text-[#6B6A65]">Il tuo account è ora completamente attivo.</p>
            <button onClick={() => nav("/dashboard")} className="btn-primary mt-8 w-full justify-center" data-testid="to-dashboard-verified">
              Vai al dashboard <ArrowRight size={16} weight="bold" />
            </button>
          </>
        )}
        {status === "invalid" && (
          <>
            <Warning size={44} weight="fill" className="text-[#7C8B6E] mx-auto" />
            <h1 className="font-editorial text-3xl mt-6">Link non valido</h1>
            <p className="mt-4 text-[#6B6A65]">Il token è scaduto o non è corretto.</p>
            <button onClick={() => nav("/dashboard")} className="btn-outline mt-8 w-full justify-center" data-testid="to-dashboard-invalid">
              Vai al dashboard
            </button>
          </>
        )}
      </div>
    </div>
  );
}
